import { useApi } from '@hooks/useApi';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { queryKeys } from '@utils/consts';
import { AcquirerUser, ApiError } from '@root/globalTypes';
import { isError } from '@utils/apiHelpers';
import { UpdateAcquirerUserData } from '@services/types';

type UpdateUserParams = {
  id: string;
  acquirerId: string;
  callback: (data: AcquirerUser) => void;
};

export function useUpdateAcquirerUser({ id, acquirerId, callback }: UpdateUserParams) {
  const { query } = useApi();
  const queryClient = useQueryClient();
  const [apiError, setApiError] = useState<ApiError | null>(null);

  const { mutate, isPending } = useMutation({
    mutationFn: (data: UpdateAcquirerUserData): Promise<AcquirerUser> => {
      return query({
        path: `v1/staff/acquirers/${acquirerId}/users/${id}`,
        data: data,
        opt: {
          method: 'PUT',
        },
      });
    },
    onSettled: (data) => {
      if (!data) return;
      if (isError(data)) {
        setApiError(data);
      } else {
        callback(data);
      }
    },
    onSuccess: async () => {
      await queryClient.refetchQueries({ queryKey: [...queryKeys.acquirerUsers, acquirerId] });
    },
  });

  return {
    mutate,
    isPending,
    error: apiError,
  };
}
